module.exports = __WEBPACK_EXTERNAL_MODULE__angular_localize_init__;